var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowRecall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.659,
    height: 12,
    viewBox: "0 0 11.659 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46839",
    "data-name": "Path 46839",
    d: "M.148,76.819l4.484-4.7a.4.4,0,0,1,.483-.089.534.534,0,0,1,.265.477v2.623a6.542,6.542,0,0,1,6.045,6.132l.23,2.135a.532.532,0,0,1-.3.556.383.383,0,0,1-.15.031.439.439,0,0,1-.38-.245l-.451-.841c-.9-1.665-2.686-3.609-4.789-3.609H5.381V81.9a.534.534,0,0,1-.265.477.4.4,0,0,1-.482-.089l-4.484-4.7a.582.582,0,0,1,0-.776Z",
    transform: "translate(0 -71.989)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowRecall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_arrowRecall.dd1a43824698c11f35724134d893c2db.svg";